import { makeStyles, Box, Avatar } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
    mediaIconList1: {
        display: 'inline-flex',
        alignItems: 'center'
    },
    avatar: {
        width: '50px',
        height: '50px',
        border: '2px solid white',
    },
    textAvatar: {
        width: '50px',
        height: '50px',
        border: '2px solid white',
        color: 'white',
        backgroundColor: '#315CD5',
    },
    helpText: {
        color: '#315CD5',
    }
}));

const ImageGroup = (props) => {
    const classes = useStyles();
    const overlaySize = 40;

    if (!props.images) {
        return null;
    }

    return (
        <Box className={classes.mediaIconList1}>
            {
                props.images?.map((val, idx) => {
                    return (
                        <Avatar
                            className={classes.avatar}
                            src={val}
                            key={idx}
                            style={{ transform: `translateX(-${idx * overlaySize}%)` }}
                        />
                    )
                })
            }
            <Avatar
                className={classes.textAvatar}
                style={{ transform: `translateX(-${props.images.length * overlaySize}%)` }}
            >
                {props.applicationCount}
            </Avatar>
            <h4
                className={classes.helpText}
                style={{ transform: `translateX(${(props.images.length + 1) * -overlaySize + 60}%)` }}
            >
                {props.helpText}
            </h4>
        </Box>
    )
}

export default ImageGroup;
